import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("label", null, "Project", -1)

import { ref } from 'vue'
import { notification } from 'ant-design-vue'
import axios from 'axios'
import { DownloadOutlined } from '@ant-design/icons-vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'DiaryUnworkableDaysExportButton',
  props: {
    projects: null
  },
  setup(__props: any) {



const loading = ref(false)
const showModal = ref(false)

const projectId = ref<number|null>(null)

function toggleModal () : void {
  showModal.value = !showModal.value
  projectId.value = null
}

function download () {
  loading.value = true
  axios.get(process.env.VUE_APP_API_URL + '/diaries/project/' + projectId.value + '/export/unworkableDays', { responseType: 'arraybuffer' }).then(r => {
    const url = window.URL.createObjectURL(new Blob([r.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', 'Overzicht_onwerkbare_dagen_' + getCurrentDate() + '.pdf')
    document.body.appendChild(link)
    link.click()
    link.remove()
    toggleModal()
    notification.success({
      message: 'Download gestart.',
      description: 'De download is succesvol gestart. Ga naar je download map om het overzicht te bekijken.',
      duration: 5
    })
  }).catch(() => {
    notification.error({
      message: 'Download NIET gestart.',
      description: 'De download is mislukt. Probeer het later nog een keer.',
      duration: 0
    })
  }).finally(() => {
    loading.value = false
  })
}

function getCurrentDate () : string {
  return new Date().toLocaleDateString('nl-NL')
}

function filterItems (input:string, item:{ name:string }) {
  return item.name.toLowerCase().indexOf(input.toLowerCase()) >= 0
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_button, { onClick: toggleModal }, {
      default: _withCtx(() => [
        _createVNode(_unref(DownloadOutlined)),
        _createTextVNode(" Overzicht onwerkbare dagen ")
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      title: "Overzicht onwerkbare dagen downloaden.",
      "ok-text": "Downloaden",
      visible: showModal.value,
      "ok-button-props": { loading: loading.value, disabled: loading.value || !projectId.value },
      onOk: download,
      onCancel: toggleModal
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_row, { class: "no-mb" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 24 }, {
              default: _withCtx(() => [
                _hoisted_1,
                _createVNode(_component_a_select, {
                  "filter-option": filterItems,
                  fieldNames: { label: 'name', value: 'id' },
                  options: __props.projects,
                  value: projectId.value,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((projectId).value = $event)),
                  "show-search": ""
                }, null, 8, ["options", "value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible", "ok-button-props"])
  ], 64))
}
}

})